<div>
  <div *ngIf="!loadingRules" class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.cepRule' | transloco}} {{cepRule.nameComplexRule}}
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button pButton pRipple class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
                  *ngIf="'ROLE_OPERATOR' | userHasRole" label="{{'common.edit' | transloco}}"
                  icon="pi pi-pencil" routerLink="../edit"></button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loadingRules" class="card p-0 pt-4 mb-0 w-full">
    <app-table-skeleton [rows]="1"></app-table-skeleton>
  </div>

  <div class="with-margin">
    <div class="grid" style="margin-top: 8px">
      <div class="col-12">
        <div class="card main-height">
          <div class="card-header pt-1"><h4 class="mb-1">{{'misc.cepRuleInfo' | transloco}}</h4></div>
          <hr>
          <table *ngIf="!loadingRules" class="details-table striped-table">
            <tr>
              <td class="p-3 bold">{{'attribute.name' | transloco}}</td>
              <td>{{cepRule.nameComplexRule}}</td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
              <td>{{cepRule.tenant.name}}</td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'model.organization' | transloco}}</td>
              <td
                [class.font-italic]="!cepRule.organization">{{cepRule.organization ? cepRule.organization.name : ('empty.organization' | transloco)}}</td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'attribute.state' | transloco}}</td>
              <td>
                <span *ngIf="cepRule.ruleState === 'ACTIVE'">{{'common.active' | transloco}}</span>
                <span *ngIf="cepRule.ruleState === 'PAUSE'">{{'common.inactive' | transloco}}</span>
              </td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'attribute.result' | transloco}}</td>
              <td *ngIf="cepRule.lastEvaluation != null && cepRule.lastEvaluation != undefined">
                <p [className]="cepRule.lastEvaluation ? 'success-color' : 'danger-color'">
                  <i [className]="cepRule.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
                  {{(cepRule.lastEvaluation ? 'common.true' : 'common.false') | transloco}}
                </p>
              </td>
              <td *ngIf="cepRule.lastEvaluation == null || cepRule.lastEvaluation == undefined">
              </td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'attribute.lastValueEvaluated' | transloco}}</td>
              <td>
                {{cepRule.lastSensorEvaluated}}&nbsp;
                <span *ngIf="cepRule.lastValueEvaluated">({{cepRule.lastValueEvaluated}})</span>
              </td>
            </tr>
            <tr>
              <td class="p-3 bold">{{'attribute.evaluationDate' | transloco}}</td>
              <td>{{cepRule.evaluationDate | customDate}}</td>
            </tr>
          </table>
          <app-table-skeleton *ngIf="loadingRules" [striped]="true" [rows]="7"></app-table-skeleton>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'model.cepRulesSimple' | transloco}}</h4>
          </div>
          <hr>
          <p-table
            [(first)]="first"
            [(rows)]="rows"
            [totalRecords]="totalSimpleRules"
            [responsive]="true"
            [value]="simpleRules"
            [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
            [paginator]="true"
            [rowsPerPageOptions]="[10,25,50]"
            sortField="name"
            styleClass="p-datatable-striped"
            responsiveLayout="stack"
            dataKey="name"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="selection-column-width"></th>
                <th pSortableColumn="name">
                  {{'attribute.name' | transloco}}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="aggregatorFunctionType">
                  {{'attribute.aggregatorFunctionType' | transloco}}
                  <p-sortIcon field="aggregatorFunctionType"></p-sortIcon>
                </th>
                <th pSortableColumn="limitOperatorType">
                  {{'attribute.condition' | transloco}}
                  <p-sortIcon field="limitOperatorType"></p-sortIcon>
                </th>
                <th pSortableColumn="windowTime">
                  {{'attribute.windowTime' | transloco}}
                  <p-sortIcon field="windowTime"></p-sortIcon>
                </th>
                <th pSortableColumn="transformationType">
                  {{'attribute.transformationCondition' | transloco}}
                  <p-sortIcon field="transformationType"></p-sortIcon>
                </th>
                <th pSortableColumn="lastEvaluation">
                  {{'attribute.result' | transloco}}
                  <p-sortIcon field="lastEvaluation"></p-sortIcon>
                </th>
                <th pSortableColumn="lastValueEvaluated">
                  {{'attribute.lastValueEvaluated' | transloco}}
                  <p-sortIcon field="lastValueEvaluated"></p-sortIcon>
                </th>
                <th pSortableColumn="evaluationDate">
                  {{'attribute.evaluationDate' | transloco}}
                  <p-sortIcon field="evaluationDate"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rule let-expanded="expanded">
              <tr *ngIf="!loadingRules" class="fadein">
                <td>
                  <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                  <button
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [pRowToggler]="rule"
                    pButton
                    pRipple
                    class="p-button-text p-button-rounded p-button-plain"
                    type="button"
                  ></button>
                </td>
                <td>
                  <p class="text-right md:text-left">{{rule.name}}</p>
                </td>
                <td>
                  <p class="text-right md:text-left">{{rule.aggregatorFunctionType}}</p>
                </td>
                <td>
                  <p class="text-right md:text-left">
                    <p-tag value="{{rule.limitOperatorType}}({{rule.limitValue}})" severity="info"></p-tag>
                  </p>
                </td>
                <td>
                  <p class="text-right md:text-left">{{rule.windowTime}} min</p>
                </td>
                <td>
                  <p *ngIf="rule.transformationType" class="text-right md:text-left">
                    <p-tag value="{{rule.transformationType}}({{rule.transformationValue}})" severity="info"></p-tag>
                  </p>
                </td>
                <td>
                  <p [className]="rule.lastEvaluation ? 'success-color' : 'danger-color'">
                    <i [className]="rule.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
                    {{(rule.lastEvaluation ? 'common.true' : 'common.false') | transloco}}
                  </p>
                </td>
                <td>
                  <p>{{rule.entitiesAndSensorIdentifiers[0]?.measurementName}}&nbsp;
                    <span>({{rule.lastValueEvaluated ? rule.lastValueEvaluated : '-'}})</span>
                  </p>
                </td>
                <td>
                  <p class="text-right md:text-left">{{rule.evaluationDate | customDate}}</p>
                </td>
              </tr>
              <tr *ngIf="loadingRules" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
                <td class="row-height-md">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-i="rowIndex">
              <tr>
                <td colspan="9">
                  <div class="p-p-3">
                    <p-table
                      [(first)]="identifiersFirst"
                      [(rows)]="identifiersRows"
                      [value]="simpleRules[i].entitiesAndSensorIdentifiers"
                      [totalRecords]="simpleRules[i].entitiesAndSensorIdentifiers.length"
                      [paginator]="true"
                      [autoLayout]="true"
                      responsiveLayout="stack"
                      styleClass="fade-in"
                      sortField="entityIdentifier"
                      dataKey="entityUuid"
                    >
                      <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="entityIdentifier">
                  {{'model.entity' | transloco}}
                  <p-sortIcon field="entityIdentifier"></p-sortIcon>
                </th>
                <th pSortableColumn="entityUuid">
                  {{'attribute.entityUuid' | transloco}}
                  <p-sortIcon field="entityUuid"></p-sortIcon>
                </th>
                <th pSortableColumn="entityType">
                  {{'attribute.entityType' | transloco}}
                  <p-sortIcon field="entityType"></p-sortIcon>
                </th>
                <th pSortableColumn="measurementName">
                  {{'attribute.measurementName' | transloco}}
                  <p-sortIcon field="measurementName"></p-sortIcon>
                </th>
                <th pSortableColumn="measurementUnit">
                  {{'model.measurementUnit' | transloco}}
                  <p-sortIcon field="measurementUnit"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entity>
              <tr>
                <td>
                  <p class="text-right md:text-left">
                    <a [routerLink]="[entity.entityType === 'DEVICE' ? '/devices' : '/assets', entity.entityUuid, 'details']">
                      {{entity.entityIdentifier}}
                    </a>
                  </p>
                </td>
                <td>
                  <p class="text-right md:text-left">
                    <app-clipboard-label [value]="entity.entityUuid" [copiedValue]="entity.entityUuid"></app-clipboard-label>
                  </p>
                </td>
                <td>
                  <p *ngIf="entity.entityType === 'DEVICE'"
                     class="text-right md:text-left">{{'model.device' | transloco}}</p>
                  <p *ngIf="entity.entityType === 'ASSET'"
                     class="text-right md:text-left">{{'model.asset' | transloco}}</p>
                </td>
                <td><p class="text-right md:text-left">{{entity.measurementName}}</p></td>
                <td>
                  <p class="text-right md:text-left"
                     *ngIf="entity.measurementTypeUnit && entity.measurementTypeUnit != ''">{{entity.measurementTypeUnit}}</p>
                  <p class="text-right md:text-left"
                     *ngIf="!entity.measurementTypeUnit || entity.measurementTypeUnit == ''">-</p>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        </td>
        </tr>
        </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalSimpleRules == 0">
                {{'pagination.empty' | transloco}}
              </div>
              <div class="flex align-items-center justify-content-between" *ngIf="totalSimpleRules > 0">
                {{'pagination.showing' | transloco}} {{first + 1}}
                {{'pagination.to' | transloco}} {{(first + rows) >= totalSimpleRules ? totalSimpleRules : (first + rows)}}
                {{'pagination.of' | transloco}} {{totalSimpleRules}}
                {{(totalSimpleRules > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
              </div>
            </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
</div>
